import React from "react";
import { Menu } from "antd";
import { MoonOutlined, SunOutlined, LogoutOutlined } from "@ant-design/icons";
import DarkModeSwitch from "../../DarkModeSwitch";
import { useDarkMode } from "src/context/DarkModeContext";
import "./UserMenu.css";

interface UserMenuProps {
    handleSignOut: () => Promise<void>;
    className?: string;
    isDarkMode: boolean;
}

const UserMenu: React.FC<UserMenuProps> = ({ handleSignOut, className, isDarkMode }) => {
    const { toggleTheme } = useDarkMode();

    const menuItems = [
        {
            key: "darkmode",
            label: (
                <div className="menu-item">
                    {isDarkMode ? <SunOutlined className="menu-icon" /> : <MoonOutlined className="menu-icon" />}
                    <span className="menu-text">{isDarkMode ? "Light Mode" : "Dark Mode"}</span>
                    <div className="dark-switch">
                        <DarkModeSwitch isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
                    </div>
                </div>
            ),
        },
        {
            key: "signout",
            label: (
            <div className="menu-item">
                <LogoutOutlined className="menu-icon" />
                <span className="menu-text">Sign Out</span>
            </div>),
            onClick: handleSignOut,
        },
    ];

    return (
        <Menu
            className={`user-menu ${className || ""} ${isDarkMode ? "dark" : "light"}`}
            theme={isDarkMode ? "dark" : "light"}
            items={menuItems}
        />
    );
};

export default UserMenu;
